import React, { useCallback } from "react";

import { useAuthUser, useLogout } from "@shared/hooks";

import { classNames, returnStringIfTrue } from "@app/helpers/componentHelpers";

import { Box, Inline, Stack } from "@fermions";

import Avatar from "@atoms/Avatar/Avatar";
import { Divider } from "@atoms/Divider/Divider";
import { Icon } from "@atoms/Icon";
import { Text } from "@atoms/Text";

import "./MobileTopNavigation.scss";

export const MobileTopNavigation = ({
  isOpen,
  onClose,
  navItems,
  handleNavigate
}: {
  isOpen: boolean;
  onClose: () => void;
  navItems: {
    name: string;
    link: string;
    state?: unknown;
    isActive?: boolean;
  }[];
  handleNavigate: (link: string, state?: unknown) => void;
}) => {
  const { userProfile } = useAuthUser();
  const { logout } = useLogout();

  const useUserLogoutWithoutParameter = useCallback(() => {
    logout({ isAutoLogout: false });
  }, [logout]);

  return (
    <>
      <Box
        className={[
          "mobile-top-navigation",
          `mobile-top-navigation--${isOpen ? "open" : "closed"}`
        ]}
        alignment="top-center"
      >
        {isOpen && (
          <Stack
            className="mobile-top-navigation__container"
            gap="200"
            width="100"
            height="100"
            padding="300"
          >
            <Stack width="100" alignment="top-center" gap="100">
              {navItems.map(item => (
                <button
                  key={item.name}
                  className={classNames([
                    "mobile-top-navigation__item",
                    returnStringIfTrue(item.isActive, "active")
                  ])}
                  onClick={() => {
                    handleNavigate(item.link, { state: item.state });
                  }}
                >
                  <Text
                    className="mobile-top-navigation__item__text"
                    text={item.name}
                  />
                </button>
              ))}
            </Stack>
            <Divider />
            <Inline width="100">
              {/* TODO: add back */}
              {/* {hostLanguages && (
          <LanguageToggle
            languages={hostLanguages?.languages}
            languagePreferences={
              manageProfile?.user?.properties?.languagePreferences?.UILanguage
            }
            defaultLng={hostLanguages?.default}
          />
        )} */}
              <Inline
                className="mobile-top-navigation__items"
                gap="100"
                alignment="right"
                width="100"
              >
                <Avatar
                  user={userProfile}
                  size="small"
                  className="mobile-top-navigation__avatar"
                />
                <button
                  className="mobile-top-navigation__logout"
                  onClick={useUserLogoutWithoutParameter}
                >
                  <Icon name="logout" className="mobile-top-navigation__icon" />
                </button>
              </Inline>
            </Inline>
          </Stack>
        )}
      </Box>
      {isOpen && (
        <Box className="mobile-top-navigation__overlay" onClick={onClose} />
      )}
    </>
  );
};
